import { HasId } from '../../../../shared/basic-data-management/has-id.interface';

export class ParcHyperviseur implements HasId {
	static readonly OMI = new ParcHyperviseur(1, 'OMI');
	static readonly SUNXPER = new ParcHyperviseur(2, 'SunXper');
	static readonly AUTRE = new ParcHyperviseur(3, 'Autre');

	static readonly ALL: ParcHyperviseur[] = [
		ParcHyperviseur.OMI,
		ParcHyperviseur.SUNXPER,
		ParcHyperviseur.AUTRE,
	];

	private constructor(
		public readonly id: number,
		public readonly label: string,
	) {}
}